import React from "react";
import { Container, Box } from "@mui/material";
// import giftCardWork from "../../assets/vactor-images/giftcardwork.svg";
import giftCardWork from "../../assets/banner-images/buy-step.jpg";

const GiftCardWorking = () => {
  return (
    <Container
      maxWidth="false"
      disableGutters={true}
      sx={{
        backgroundColor: "primary.main",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box maxWidth="lg"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

        }}
      >
        <Box
          component="img"
          src={giftCardWork}
          alt="How Gift Card Works image"
          loading="lazy"
          sx={{
            width: "100%",
            height: {
              xs: "100%",
            },
            borderRadius: {
              xs: 2,
              md: 0,
            },
          }}
        />
      </Box>
    </Container>
  );
};

export default GiftCardWorking;
